// const Tooltip = ({ text, children }) => {
//     return (
//       <div className="tooltip-container">
//         {children}
//         <div className={`tooltip ${text === "askmntor : BETA" ? "tooltip-container-custom" : ""}`}>{text}</div>
//       </div>
//     );
//   };
  
//   export default Tooltip;
import "../Tooltip.css"

const Tooltip = ({ text, position = "right", children }) => {
  return (
    <div className="tooltip-container">
      {children}
      <div className={`tooltip tooltip-${position}`}>{text}</div>
    </div>
  );
};

export default Tooltip;